import React from 'react';

class QueryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {}
    }

    onSort = (sortColumn, sortDirection) => {
        this.props.onSort(sortColumn, sortDirection);
    }

    render() {
        if (this.props.list === null)
            return (<div>Loading...</div>);

        const Comp = this.props.comp;

        const items = this.props.list.items.map((x, i) => {
            return (<Comp key={i} item={x} />);
        });
        
        return (
            <React.Fragment>
                {items}
            </React.Fragment>);
    }
}

export default QueryList;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/query/QueryList.js